import React, { useEffect, useState } from "react";
import Style from "./PayingToWho.module.scss";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import { Modal } from "react-bootstrap";
import UserInfo from "../UserInfo/UserInfo";
import moment from "moment-jalaali";
import { getUserInfoApi } from "../../../../Api/PanelAdminServices";
import { errorToast } from "../../../../Utils/Toast/Toast";
const PayingToWho = ({ data }) => {
  const [modalShowState, setModalShowState] = useState(false);
  const [refralInfoState, setRefralInfoState] = useState([]);
  const getRefralInfoHandler=(userid)=>{
    getUserInfoApi(userid,(succ,res)=>{
      if(succ){
        if(res.status===1){
          setRefralInfoState(res.info)
        }else{
          errorToast(res.message)
        }
      }else{
        console.log(res)
      }
    })
  }
  const reasonHandler = (action, amount, user_type) => {
    switch (action) {
      case "0":
        if (amount.includes("-") && user_type === "user") {
          return <p>پرداختی هزینه سفارش</p>;
        } else if (user_type === "supplier" || user_type === "deliver") {
          return <p>تکمیل سفارش!</p>;
        } else {
          return <p>سود زیرمجموعه!</p>;
        }
      case "1":
        return <p>سفارش کنسل شده!</p>;
      case "2":
        return <p> جریمه!</p>;
      case "3":
        return <p> تشویقی!</p>;
      default:
        return null;
    }
  };

  const checkUser = (item) => {
    if (
      item.user_type === "user" &&
      item.action === "0" &&
      !item.amount.includes("-")
    ) {
      return true;
    }
    return false;
  };
  let type = null;
  return (
    <div className={Style.modalHolder}>
      {data?.wallet_transactions?.map((item, index) => {
        if (item.user_type === "user") {
          type = (
            <h2
              style={{ color: "#c20c64" }}
              className={Style.toWho}
              key={index}
            >
              {" "}
              پرداخت شده به مشتری{" "}
            </h2>
          );
        } else if (item.user_type === "deliver") {
          type = (
            <h2
              style={{ color: "#c20c64" }}
              className={Style.toWho}
              key={index}
            >
              پرداخت شده به پیک
            </h2>
          );
        } else if (item.user_type === "supplier") {
          type = (
            <h2
              style={{ color: "#c20c64" }}
              className={Style.toWho}
              key={index}
            >
              پرداخت شده به فروشنده
            </h2>
          );
        }
        return (
          <div className={Style.itemHolder} key={index}>
            {type}
            <h2
              className={Style.userInfo}
              style={{color:checkUser(item)?"darkmagenta":"#000"}}
              onClick={() => {
                setModalShowState(checkUser(item))
                getRefralInfoHandler(item.user_id)
              }}
            >
              شناسه کاربر :{item.user_id}
            </h2>
            <h2 className={Style.toWho}>
              مبلغ :{" "}
              <span style={{ direction: "ltr" }}> {separate(item.amount)}</span>{" "}
               تومان 
            </h2>
            <h2 className={Style.toWho}>
              تاریخ :{" "}
              <span style={{ direction: "ltr" }}>
                {moment.unix(parseInt(item.date)).format("jYYYY/jM/jD--HH:mm")}
              </span>
            </h2>
            <h2 className={Style.toWho}>
              علت:  {reasonHandler(item.action, item.amount, item.user_type)}
            </h2>
          </div>
        );
      })}
      <Modal
        size="xl"
        show={modalShowState}
        onHide={() => setModalShowState(false)}
        style={{ backdropFilter: "blur(2px)", direction: "rtl" }}
      >
        <Modal.Header>
          <Modal.Title>اطلاعات کاربر</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ direction: "ltr" }}>
          <UserInfo
            Info={refralInfoState}
            showAddress={true}
            handleOk={() => setModalShowState(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default PayingToWho;
